// extracted by mini-css-extract-plugin
module.exports = {"badge":"widget-space--badge--1g_f_","count":"widget-space--count--2hnIP","tooltip":"widget-space--tooltip--1mzjs","tooltipText":"widget-space--tooltipText--233C6"};